<template>
  <v-menu tile v-if="subcategories.length > 0" open-on-hover min-width="250px" bottom offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        link
        text
        tile
        :class="['category-color', $vuetify.breakpoint.mdAndUp && 'category', $route.params.category === name.toLowerCase() ? 'primary--text text--darken-1 font-weight-bold' : null]"
        active-class="primary--text text--darken-1 font-weight-bold"
        v-bind="attrs"
        v-on="on"
      >
        {{ name }}
        <v-icon class="secondary--text">mdi-chevron-down</v-icon>
      </v-btn>
    </template>
    <v-list dense class="py-4" tile>
      <v-list-item
        v-for="subcategory in subcategories"
        :key="subcategory.name"
        :to="{ name: $constants.ROUTE_NAME.PRODUCT_CATEGORY, params: { category: name.toLowerCase() }, query: { subcategory: subcategory.name.toLowerCase(), brand: 'all' } }"
        link
        exact
        class="category-color text-uppercase"
        active-class="primary--text text--lighten-1 font-weight-bold"
      >
        <v-list-item-title>{{ subcategory.name }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
  <v-btn
    v-else
    :to="`/product/category/${name.toLowerCase()}`"
    :class="['category-color', $vuetify.breakpoint.mdAndUp && 'category']"
    active-class="primary--text text--darken-1 font-weight-bold"
    text
    tile
    link
  >
    {{ name }}
  </v-btn>
</template>

<script>
/*
  type Category: {
    name: String,
    link: String
  }
*/
export default {
  props: {
    // link: { type: String, required: true },
    name: { type: String, required: true },
    subcategories: { type: Array, required: false }
  }
}
</script>

<style lang="scss" scoped>
.category-color {
  &::before {
    opacity: 0;
  }
  .v-btn__content .v-icon {
    background-color: unset;
  }
}

::v-deep .font-weight-bold > .v-list-item__title {
  font-weight: 700;
}

.category:first-child {
  margin-left: auto;
}

.category:last-child {
  margin-right: auto;
}

.category {
  max-width: max(300px, 12.5%);

  ::v-deep .v-btn__content {
    white-space: normal;
    width: 100%;
    text-align: center;
  }
}
</style>
